(function ($) {
    $(document).ready(function () {
        $(".nav-language a.dropdown-toggle").click(function (e) {
            e.preventDefault();
            $(".nav-language").toggleClass("show");
            $(".dropdown-menu.lang-dropdown").hide();
        });
    });

    $(window).resize(function () {
        if ($(window).width() >= 615) {
            $(".nav-language").removeClass("show");
        }
    });
}(window.jQuery));
